function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var SaitoNFT = require('../../../lib/saito/ui/saito-nft/saito-nft');
var _require = require('./archive'),
  loadTransactionFromArchive = _require.loadTransactionFromArchive;
var ALLOWED_IMAGE_MIMES = new Set(['image/png', 'image/jpeg', 'image/svg+xml', 'image/gif', 'image/webp']);
function decodeImageDataURI() {
  var _bytes;
  var data_uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!data_uri || typeof data_uri !== 'string' || !data_uri.startsWith('data:image/')) {
    return null;
  }
  var comma = data_uri.indexOf(',');
  if (comma === -1) {
    return null;
  }
  var header = data_uri.slice(0, comma);
  var payload = data_uri.slice(comma + 1);
  var mime_match = header.match(/^data:(image\/[^;]+)/i);
  if (!mime_match) {
    return null;
  }
  var mime = mime_match[1].toLowerCase();
  if (mime === 'image/jpg') {
    mime = 'image/jpeg';
  }
  if (!ALLOWED_IMAGE_MIMES.has(mime)) {
    return null;
  }
  var bytes = null;
  if (header.includes(';base64')) {
    bytes = Buffer.from(payload, 'base64');
  } else {
    bytes = Buffer.from(decodeURIComponent(payload), 'utf8');
  }
  if (!((_bytes = bytes) !== null && _bytes !== void 0 && _bytes.length)) {
    return null;
  }
  return {
    mime: mime,
    bytes: bytes
  };
}
function initializeImageCache(_x) {
  return _initializeImageCache.apply(this, arguments);
}
function _initializeImageCache() {
  _initializeImageCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod) {
    var _i, _Object$values, summary, nft_id, _tx$returnMessage, _nft$returnImage, listing, tx, txmsg, nft, image, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!mod.app.BROWSER) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          _i = 0, _Object$values = Object.values(mod.summaries);
        case 2:
          if (!(_i < _Object$values.length)) {
            _context.n = 12;
            break;
          }
          summary = _Object$values[_i];
          nft_id = summary === null || summary === void 0 ? void 0 : summary.nft_id;
          if (!(!nft_id || mod.image_cache[nft_id])) {
            _context.n = 3;
            break;
          }
          return _context.a(3, 11);
        case 3:
          _context.p = 3;
          _context.n = 4;
          return mod.warehouse.db.returnActiveListingForBucket(summary.nft_id, summary.price);
        case 4:
          listing = _context.v;
          if (listing !== null && listing !== void 0 && listing.signature) {
            _context.n = 5;
            break;
          }
          return _context.a(3, 11);
        case 5:
          _context.n = 6;
          return loadTransactionFromArchive(mod.app, listing.signature);
        case 6:
          tx = _context.v;
          if (tx) {
            _context.n = 7;
            break;
          }
          return _context.a(3, 11);
        case 7:
          txmsg = ((_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
          _context.n = 8;
          return mod.warehouse.persistSummaryMetadata(summary.nft_id, summary.price, txmsg);
        case 8:
          _context.n = 9;
          return mod.warehouse.syncSummaryToCache(summary.nft_id, summary.price);
        case 9:
          nft = new SaitoNFT(mod.app, mod, tx, null);
          image = ((_nft$returnImage = nft.returnImage) === null || _nft$returnImage === void 0 ? void 0 : _nft$returnImage.call(nft)) || '';
          if (image) {
            mod.image_cache[nft_id] = image;
          }
          _context.n = 11;
          break;
        case 10:
          _context.p = 10;
          _t = _context.v;
          return _context.a(3, 11);
        case 11:
          _i++;
          _context.n = 2;
          break;
        case 12:
          return _context.a(2);
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _initializeImageCache.apply(this, arguments);
}
function serveCachedImageResponse(mod, res, nft_id) {
  var image_data = mod.image_cache[nft_id];
  if (!image_data) {
    res.status(404).end();
    return;
  }
  var parsed = decodeImageDataURI(image_data);
  if (!parsed) {
    res.status(404).end();
    return;
  }
  res.writeHead(200, {
    'Content-Type': parsed.mime,
    'Content-Length': parsed.bytes.length
  });
  res.end(parsed.bytes);
}
module.exports = {
  ALLOWED_IMAGE_MIMES: ALLOWED_IMAGE_MIMES,
  decodeImageDataURI: decodeImageDataURI,
  initializeImageCache: initializeImageCache,
  serveCachedImageResponse: serveCachedImageResponse
};